import { TEXT_KEY, QUERY_KEY, SORT_KEY, ALL_FACETS_KEY, SELECTED_FACETS_KEY, LIMIT_KEY, OFFSET_KEY, VERSION_KEY, VERSION_CAAS, PRODUCT_TYPE, } from '@yme/common/constants';
import { Network } from '@yme/services/network';
import { DigitalDataMutation, isInsideGenericClickEvent, setDigitalData } from '@yme/utils/common';
const cacheKeyFromParams = (params) => {
    return JSON.stringify(params);
};
const cache = new Map();
const cacheTimeout = 1000 * 60 * 5; // 5 minutes
const setCacheTimeout = (key, timeout = cacheTimeout) => {
    // clear previous timeout
    setTimeout(() => {
        cache.delete(key);
    }, timeout);
};
export async function getFilteredProducts({ endpoint, config: { query, facets = '', selectedFacets = '', sortOrder, limit, offset = 0, search = '', productType, }, }) {
    const params = {
        [QUERY_KEY]: query,
        [ALL_FACETS_KEY]: facets,
        [SELECTED_FACETS_KEY]: selectedFacets,
        [SORT_KEY]: sortOrder,
        [LIMIT_KEY]: limit,
        [OFFSET_KEY]: offset,
        [TEXT_KEY]: search,
        [PRODUCT_TYPE]: productType,
        [VERSION_KEY]: VERSION_CAAS, // Temporary prop - for compatibility of two approaches (property lang transfer)
    };
    const shouldReportAnalytics = isInsideGenericClickEvent();
    const cacheKey = cacheKeyFromParams(params);
    const cachedResult = cache.get(cacheKey);
    if (cachedResult) {
        const result = JSON.parse(cachedResult);
        if (shouldReportAnalytics) {
            setDigitalData(DigitalDataMutation.PLP_VIEW_FILTER_RESULT, {
                searchTerm: params[TEXT_KEY],
                facets: params[SELECTED_FACETS_KEY],
                sort: params[SORT_KEY],
                query: params[QUERY_KEY],
                resolvedFacets: result.facets,
            });
        }
        return Promise.resolve(JSON.parse(cachedResult));
    }
    const response = await Network.get(endpoint, {
        params,
    });
    const result = response.data;
    result.facets = result.facets.filter((facet) => {
        // filter out translatedAccessoryTypes
        return facet !== null && typeof facet === 'object' && !('translatedAccessoryTypes' in facet);
    });
    if (shouldReportAnalytics) {
        setDigitalData(DigitalDataMutation.PLP_VIEW_FILTER_RESULT, {
            searchTerm: params[TEXT_KEY],
            facets: params[SELECTED_FACETS_KEY],
            sort: params[SORT_KEY],
            query: params[QUERY_KEY],
            resolvedFacets: result.facets,
        });
    }
    cache.set(cacheKey, JSON.stringify(result));
    setCacheTimeout(cacheKey);
    return result;
}
